"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SvgExpandLeft = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M36.44.44a1.5 1.5 0 0 1 0 2.12L15.001 24l21.44 21.44a1.5 1.5 0 0 1-2.122 2.12L12.881 26.123h-.001a2.997 2.997 0 0 1-.003-4.24v-.001l.002-.002L34.32.439a1.5 1.5 0 0 1 2.121 0zM15 24v-.001m-.002.004L15 24", clipRule: "evenodd" }))); };
exports.default = SvgExpandLeft;
